var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVirtual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1250_205816)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4698 15.7271H10.6992V18.6429H12.4698V15.7271Z",
    fill: "#2A2A33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1603 3.10059H3.00939C2.43358 3.10059 1.9668 3.56737 1.9668 4.14318V15.4575C1.9668 16.0333 2.43358 16.5001 3.00939 16.5001H20.1603C20.7361 16.5001 21.2029 16.0333 21.2029 15.4575V4.14318C21.2028 3.56737 20.7361 3.10059 20.1603 3.10059Z",
    fill: "#3F3F4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1281 4.55371H4.04164C3.69826 4.55371 3.41992 4.83209 3.41992 5.17543V14.4252C3.41992 14.7686 3.6983 15.047 4.04164 15.047H19.1281C19.4715 15.047 19.7498 14.7686 19.7498 14.4252V5.17547C19.7498 4.83209 19.4715 4.55371 19.1281 4.55371Z",
    fill: "#74D6FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6585 7.48574C14.5024 6.81667 13.9025 6.31831 13.1858 6.31831C12.864 6.31831 12.566 6.41907 12.3209 6.59031C12.0027 6.08112 11.4376 5.74219 10.7929 5.74219C9.7984 5.74219 8.99219 6.54836 8.99219 7.54293C8.99219 7.54369 8.99219 7.5445 8.99219 7.54526C8.99237 7.67149 9.09825 7.77221 9.22448 7.77221H14.4324C14.5825 7.77216 14.6927 7.63196 14.6585 7.48574Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.46523 9.86741L5.07812 15.047H13.1386L10.7515 9.86741C10.1051 8.46477 8.11165 8.46477 7.46523 9.86741Z",
    fill: "#735359"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7506 9.86775C10.3475 8.99303 9.4205 8.66398 8.62305 8.88024C9.10438 9.01078 9.53851 9.33979 9.78185 9.86775L12.169 15.0474H13.1377L10.7506 9.86775Z",
    fill: "#8C656D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1289 15.0473C19.4723 15.0473 19.7506 14.7689 19.7506 14.4255V12.541L17.4001 7.44065C16.6775 5.87265 14.449 5.87265 13.7263 7.44065L10.2207 15.0473H19.1288H19.1289Z",
    fill: "#8C656D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3994 7.44059C16.9582 6.48348 15.9564 6.11171 15.0781 6.32307C15.6387 6.45797 16.1491 6.8297 16.4306 7.44059L18.7812 12.5409V14.4254C18.7812 14.7688 18.5028 15.0472 18.1595 15.0472H19.1282C19.4716 15.0472 19.7499 14.7688 19.7499 14.4254V12.5409L17.3994 7.44059Z",
    fill: "#A3767F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.41992 11.9765V14.4255C3.41992 14.7689 3.6983 15.0472 4.04164 15.0472H13.1832C10.0602 12.3379 6.42515 11.4114 3.41992 11.9765Z",
    fill: "#55A681"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4966 15.0472H13.1833C10.0602 12.3379 6.42515 11.4114 3.41992 11.9765V12.8556C6.26932 12.5532 9.47081 13.239 12.4966 15.0472Z",
    fill: "#5FBA91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7501 14.4257V12.0702C19.7501 12.0702 14.0741 11.2374 10.8438 15.0474H19.1284C19.4718 15.0474 19.7501 14.769 19.7501 14.4257Z",
    fill: "#5FBA91"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8848 14.9998C14.7431 12.3192 19.7496 13.0538 19.7496 13.0538V12.0701C19.7496 12.0701 14.122 11.2449 10.8848 14.9998Z",
    fill: "#6BD1A3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9622 8.09519C21.712 7.50249 21.1254 7.08643 20.4417 7.08643C19.9382 7.08643 19.4878 7.31225 19.1852 7.66776C19.009 7.58942 18.8142 7.54562 18.609 7.54562C17.954 7.54562 17.4029 7.98927 17.2389 8.59234C17.1702 8.57577 17.0988 8.56597 17.025 8.56597C16.6389 8.56597 16.3091 8.80635 16.1769 9.1456C16.115 9.30431 16.2324 9.47578 16.4027 9.47578H22.758C22.8892 9.47578 22.9998 9.37133 23.0001 9.24011C23.0001 9.23931 23.0001 9.23845 23.0001 9.23764C23 8.6409 22.5445 8.15062 21.9622 8.09519Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.802 8.09519C5.55187 7.50249 4.96523 7.08643 4.28152 7.08643C3.77808 7.08643 3.32761 7.31225 3.02501 7.66776C2.84892 7.58942 2.65405 7.54562 2.44885 7.54562C1.79384 7.54562 1.24269 7.98927 1.07873 8.59234C1.01 8.57577 0.938663 8.56597 0.864811 8.56597C0.478753 8.56597 0.148936 8.80635 0.0167312 9.1456C-0.0451262 9.30431 0.0722097 9.47578 0.242554 9.47578H6.59788C6.72905 9.47578 6.83965 9.37133 6.83991 9.24011C6.83991 9.23931 6.83991 9.23845 6.83991 9.23764C6.83987 8.6409 6.38436 8.15062 5.802 8.09519Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3437 18.1064H10.8244C9.83409 18.1064 9.03125 18.9093 9.03125 19.8996H14.1369C14.1368 18.9093 13.3341 18.1064 12.3437 18.1064Z",
    fill: "#3F3F4D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1250_205816"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVirtual);
export default __webpack_public_path__ + "static/media/Virtual.f19ed2c22c2d1beb65d9c70d40e824b2.svg";
export { ForwardRef as ReactComponent };